import React from "react";
import "./index.scss";
import { useTranslation } from "react-i18next";
import emptyInvoice from "../../assets/images/emptyInvoice.png";
import { useNavigate } from "react-router-dom";
// --- Add for quotes support ---
import InvoiceList from "../../pages/Invoices/InvoiceList";
import QuoteList from "../../pages/Quotes/QuoteList";
import { useGetInvoicesQuery } from "store/invoice/invoiceApi";
import { useGetQuotesQuery } from "store/quote/quoteApi";
import { PATHS } from "config/paths";

const EmptyState = ({ type = "invoice" }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // Fetch both invoices and quotes
  const {
    data: invoices,
    isLoading: isLoadingInvoices,
    error: errorInvoices,
  } = useGetInvoicesQuery();
  const {
    data: quotes,
    isLoading: isLoadingQuotes,
    error: errorQuotes,
  } = useGetQuotesQuery();

  // Navigation handlers
  const handleCreateInvoice = () => {
    navigate(PATHS.INVOICES.CREATE);
  };
  const handleCreateQuote = () => {
    navigate(PATHS.QUOTES.CREATE);
  };

  const handleCreateAvoir = () => {
    navigate(PATHS.AVOIRS.CREATE);
  };

  // Loading state
  if (
    (type === "invoice" && isLoadingInvoices) ||
    (type === "quote" && isLoadingQuotes)
  ) {
    return <div>Loading...</div>;
  }

  // Show list if data exists
  if (type === "invoice" && invoices?.data?.length > 0) {
    return <InvoiceList invoices={invoices.data} />;
  }
  if (type === "quote" && quotes?.data?.length > 0) {
    return <QuoteList quotes={quotes.data} />;
  }

  // Empty state UI
  return (
    <div className="invoice-empty-state">
      <img
        src={emptyInvoice}
        alt={type === "invoice" ? "empty invoice Logo" : "empty quote Logo"}
        className="logo"
      />
      <h2>
        {type === "invoice"
          ? t("invoice.empty_title")
          : type === "avoir"
          ? t("avoir.empty_title")
          : t("quote.empty_title")}
      </h2>

      <p>
        {type === "invoice"
          ? t("invoice.empty_description")
          : type === "avoir"
          ? t("avoir.empty_description")
          : t("quote.empty_description") ||
            "Vous n'avez pas encore créé de devis."}
      </p>

      <button
        className="create-invoice-btn"
        onClick={
          type === "invoice"
            ? handleCreateInvoice
            : type === "avoir"
            ? handleCreateAvoir
            : handleCreateQuote
        }>
        {type === "invoice"
          ? t("invoice.create_button")
          : type === "avoir"
          ? t("avoir.create_button")
          : t("quote.create_button") || "Créer un devis"}
      </button>
    </div>
  );
};

export default EmptyState;
